module.exports = __webpack_public_path__ + "static/media/aligenie.64b10b69.jpg";